import { BigNumber } from "ethers";
import { getPriceFeedsUpdateData } from "pages/BorrowerNewDashboard/hooks/PITContract/handleGetExpiredPriceFeed";

const cacheChainIds = {};

export const getDataToUpdatePrice = async (tokenAddressList = [], PriceContract) => {
  if (!PriceContract) {
    return {
      priceIds: [],
      payableAmount: BigNumber.from(0),
      updateData: [],
    };
  }

  const { chainId } = await PriceContract.provider.getNetwork();

  if (!cacheChainIds[chainId]) {
    cacheChainIds[chainId] = {};
  }

  const sToken = tokenAddressList.sort();
  const tokenAddressKeys = sToken.join(",").toLowerCase();

  if (cacheChainIds[chainId] && cacheChainIds[chainId][tokenAddressKeys]) {
    if (cacheChainIds[chainId][tokenAddressKeys].expired < Date.now()) {
      delete cacheChainIds[chainId][tokenAddressKeys];
    } else {
      console.info("Fetch from cache", cacheChainIds[chainId][tokenAddressKeys]);
      return cacheChainIds[chainId][tokenAddressKeys].data;
    }
  }

  const { priceIds, updateFee } = await PriceContract.getExpiredPriceFeeds(
    sToken,
    BigNumber.from(15)
  );

  let updateData = [];
  if (priceIds.length > 0) {
    updateData = await getPriceFeedsUpdateData(priceIds);
  }

  cacheChainIds[chainId][tokenAddressKeys] = {
    expired: Date.now() + 60 * 1000,
    data: {
      priceIds,
      payableAmount: updateFee,
      updateData,
    },
  };

  return {
    priceIds,
    payableAmount: updateFee,
    updateData,
  };
};
